import React, { useState } from 'react';


import {
    Alert,
    Card,
    Input,
    Button,
    Typography,
    IconButton,
    Textarea,

} from "@material-tailwind/react";



import { } from "@heroicons/react/24/outline";

import { XMarkIcon } from '@heroicons/react/24/outline';
import { showAlert } from './Alert.jsx';




export default function CropCard(props) {


    const [session] = useState(localStorage.getItem("session") || null);

    const [cropid, setCropid] = useState(props.cropid || 0);
    const [cropname, setCropname] = useState(props.cropname || "");
    
    const [sendDisabled, setSendDisabled] = useState(false);



    function cancelClose() {
        props.close();
    }


    function messageUpdate(e) {
        setMessage(e);
    }



    function handleDataResponse(data) {
        setSendDisabled(false); //tymczasowo odblokuj przycisk wyślij
        if (data.status === "ok") {
            showAlert("green", data.message, 4000);
            props.close();
        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 4000);
        }
    }



    function handleSubmit(e) {
        e.preventDefault();
        console.log("cropid");
        console.log(cropid);
        console.log("props.cropid");
        console.log(props.cropid);
        console.log("props");
        console.log(props);
        var action="create";
        if (cropid>0) action="update";


        setSendDisabled(true); //tymczasowo zablokuj przycisk wyślij
        var bodydata = JSON.stringify({ action: action, session: session, cropname: cropname.trim() , id : cropid}); //create or update if exists
        console.log(bodydata);
        
        fetch('https://online.mysoil.pl/cgi-bin/uprawy.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'

        })
            .then(res => res.json())
            .then(data => { console.log("data"); console.log(data); handleDataResponse(data); })
        
    }




    return (
        <div className='absolute w-full h-full top-0 items-center justify-cener m-auto z-[30] flex place-content-center bg-black/50 '>

            <Card color="white" className="w-full max-w-[20rem] mx-auto rounded-lg max-h-[94vh] overflow-y-auto" shadow={false}>

                <div className="flex items-center justify-between gap-4 w-auto bg-gradient-to-br from-teal-500/75 to-cyan-500/75 pt-2 pb-2 rounded-t-lg">
                    <Typography color="white" variant="h6" className="mt-2 pl-12 font-normal mx-auto">
                        Płodozmian
                    </Typography>
                    <IconButton variant='text' className='right-2' color="white" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>

                </div>
                <form className="mt-6 mb-2 mx-auto w-full max-w-[20rem]  items-center justify-center px-6" onSubmit={handleSubmit}>
                    <div className="mb-6 flex flex-col gap-4 w-auto items-center justify-center ">



                        <Input size="md" label="Nazwa płodozmianu" className="shadow-md" value={cropname} onChange={e=> setCropname(e.target.value)} />


                        <Button className="flex items-center max-w-[10rem] my-0 justify-center bg-gradient-to-br from-teal-500 to-cyan-500 mx-auto" disabled={sendDisabled} data-refresh={true} fullWidth type="submit">
                            Zapisz
                        </Button>
                    </div>

                </form>
            </Card>

        </div>
    );
}

